import axios from "@/libs/api.request";
export const getZajiMapping = params => {
  return axios.request({
    url: "/common/zajilCityMapping",
    method: "GET",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/common/zajilCityMapping/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/common/zajilCityMapping/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/common/zajilCityMapping/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/common/zajilCityMapping",
    method: "POST",
    data
  });
};
